import React from 'react'

function HomeIcon({className, size}) {
  return (
    <svg
      class={`h-6 w-6 text-inherit ${className}`}
      width="24"
      height="24"
      viewBox={`0 0 ${size || '24'} ${size || '24'}`}
      stroke-width="2"
      stroke="currentColor"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      {' '}
      <path stroke="none" d="M0 0h24v24H0z" />{' '}
      <polyline points="5 12 3 12 12 3 21 12 19 12" />{' '}
      <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />{' '}
      <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
    </svg>
  )
}

export default HomeIcon
